import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import { FeatureAttribute } from "@/types/cds/featureAttribute";
import { apiGet } from "@/services/api";

@Module({ namespaced: true, name: "Cds" })
class Cds extends VuexModule {
  private _features: FeatureAttribute[] = [];
  private _allVesselsFeatures: Map<number, FeatureAttribute[]> = new Map();

  //  @Getters
  public get featureById(): (featureId: number) => FeatureAttribute | undefined {
    return (featureId: number): FeatureAttribute | undefined => this._features.filter(f => f.id === featureId)[0];
  }

  public get featuresByVessel(): (vesselId: number) => FeatureAttribute[] | undefined {
    return (vesselId: number): FeatureAttribute[] | undefined => this._allVesselsFeatures.get(vesselId);
  }

  public get featureByVesselAndId(): (vesselId: number, featureId: number) => FeatureAttribute | undefined {
    return (vesselId: number, featureId: number): FeatureAttribute | undefined => this._allVesselsFeatures.get(vesselId)?.find(f => f.id === featureId);
  }

  public get featureByVesselAndName(): (vesselId: number, name: string) => FeatureAttribute | undefined {
    return (vesselId: number, name: string): FeatureAttribute | undefined => this._allVesselsFeatures.get(vesselId)?.find(f => f.name === name);
  }

  //  @Actions
  @Action({ rawError: true })
  public async fetchFeatures(): Promise<FeatureAttribute[]> {
    try {
      const features = await apiGet<FeatureAttribute[]>("/Cds/Features");
      this.context.commit("SET_FEATURES", features);
      return features;
    } catch (error) {
      throw ({ message: "Failed to fetch all features.", error });
    }
  }

  @Action({ rawError: true })
  public async fetchVesselFeatures(vesselId: number): Promise<FeatureAttribute[]> {
    try {
      const vesselFeatures = await apiGet<FeatureAttribute[]>(`/Cds/Features?vesselId=${vesselId}`);
      this.context.commit("SET_VESSEL_FEATURES", { vesselId: vesselId, vesselFeatures: vesselFeatures });
      return vesselFeatures;
    } catch (error) {
      throw ({ message: "Failed to fetch vessel's features.", error });
    }
  }

  //  @Mutations
  @Mutation
  public SET_FEATURES(features: FeatureAttribute[]): void {
    this._features = features;
  }

  @Mutation
  public SET_VESSEL_FEATURES(data: { vesselId: number, vesselFeatures: FeatureAttribute[] }): void {
    this._allVesselsFeatures.set(data.vesselId, data.vesselFeatures);
  }
}

export default Cds;
